export const SUPPORTED_MEDIA_MIME_TYPES = [
  'image/jpeg',
  'image/jpg',
  'image/png',
  'image/gif',
  'image/webp',
  'video/mp4',
  'video/mov',
  'video/quicktime',
  'video/avi',
  'video/x-msvideo',
  'video/webm'
];

export const SUPPORTED_MEDIA_EXTENSIONS = [
  '.jpeg',
  '.jpg',
  '.png',
  '.gif',
  '.webp',
  '.mp4',
  '.mov',
  '.avi',
  '.webm'
];

export const SUPPORTED_MEDIA_LABEL = 'JPG, PNG, GIF, WebP, MP4, MOV, AVI, WebM';

const VIDEO_MIME_TYPES = [
  'video/mp4',
  'video/mov',
  'video/quicktime',
  'video/avi',
  'video/x-msvideo',
  'video/webm'
];

export const SUPPORTED_MEDIA_ACCEPT = [
  'image/*',
  ...VIDEO_MIME_TYPES,
  '.mp4',
  '.mov',
  '.avi',
  '.webm'
].join(',');

export const isSupportedMediaFile = (file) => {
  if (!file) {
    return false;
  }

  if (typeof File !== 'undefined' && !(file instanceof File)) {
    return false;
  }

  const mimeType = (file.type || '').toLowerCase();
  if (mimeType && SUPPORTED_MEDIA_MIME_TYPES.includes(mimeType)) {
    return true;
  }

  const fileName = (file.name || '').toLowerCase();
  return SUPPORTED_MEDIA_EXTENSIONS.some((extension) => fileName.endsWith(extension));
};
